"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Navbar = ({ active }) => {
    const [showVisualizations, setShowVisualizations] = (0, react_1.useState)(false);
    return (react_1.default.createElement("header", { className: "site-header" },
        react_1.default.createElement("div", { className: "container header-inner" },
            react_1.default.createElement("div", { className: "brand" }, "Maths Explorer"),
            react_1.default.createElement("nav", null,
                react_1.default.createElement("ul", { className: "nav" },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { className: active === 'home' ? 'active' : '', href: "#/home" }, "Home")))))));
};
exports.default = Navbar;
